export function yearsBetweenDates({ start, end }: { start: Date; end: Date }) {
  if (start.getTime() > end.getTime()) {
    throw new Error("Start date must be before end date");
  }
  const yearsSinceDate =
    (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24 * 365.25);
  return Number(yearsSinceDate);
}
